import React, { useState } from "react";

import SubMenu from "./SubMenu";
import { logout } from "../../slice/authSlice";
import { useAppDispatch, useAppSelector } from "../../hook";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { logoutUser } from "../../../common/api/authApi";
import { useTranslation } from "react-i18next";
import { normalizedLocale } from "../../../common/libs/normalizedLocale";
import { deleteRoleState } from "../../slice/roleMatrix";
import { roleMatrix } from './../../slice/roleMatrix';

function SideNavbar() {
  const [open, setOpen] = useState(true);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const locale = normalizedLocale(i18n.language);
  const roleMatrix=useAppSelector(state=>state.roleMatrix);
  const userData=useAppSelector(state=>state.auth.userData)
  const userDataRole=userData.role[0]
  const Menus = [
    {
      title: t("submenu.mainPage"),
      icon: "/icons/home.svg",
      route: "/main",
      roleId:1,
    },
    ...(userDataRole === "ROLE_ADMIN"
      ? [
          {
            title: t("navbar.users"),
            icon: "/icons/user.svg",
            route: "/users",
            roleId: 11,
          },
        ]
      : []),,
    {
      title: t("submenu.check"),
      icon: "/icons/datamatrix.svg",
      roleId:2,
      SubMenuItems: [
        { title: t("submenu.recieve_checks"), route: "/check", roleId:12 },
        { title: t("submenu.error_checks"), route: "/error-ofd", roleId:4 },
      ],
    },
    {
      title:t("submenu.system"),
      icon: "/icons/document.svg",
      route: "/systemreceiver",
      roleId:11,
    },
    {
      title: t("submenu.cache_clear"),
      icon: "/icons/broom.svg",
      route: "/cache",
      roleId: 11,
    },
    {
      title:t("submenu.ofd"),
      icon: "/icons/productCatalog.svg",
      route: "",
      roleId:13,
      SubMenuItems: [
        { title: t("ofd.ofdList"), route: "/ofd", roleId: 13 },
        { title: t("ofd.certificate_upload"), route: "/ofd/certificates", roleId: 13 },
      ],
    }
    // { title: t("submenu.reports"), icon: "/icons/piechart.svg", route: "" },
  ];

  const Logout = { title: t("submenu.logout"), icon: "/icons/exit.svg" };

  // Функция для выхода пользователя
  const handleLogout = async () => {
    const refreshToken = Cookies.get("refresh_token");
    console.log(refreshToken);
    if (refreshToken) {
      try {
        await logoutUser(refreshToken);
        dispatch(deleteRoleState);
        dispatch(logout());
        navigate("/authorization");
      } catch (error) {
        dispatch(deleteRoleState);
        dispatch(logout());
        navigate('/authorization');
      }
    } else {
      // Если refreshToken не найден, просто диспатчим действие logout
      dispatch(deleteRoleState);
      dispatch(logout());
      navigate("/authorization");
    }
  };

  return (
    <nav
      className={` ${
        open ? "w-72" : "w-20 "
      } overflow-hidden bg-white  p-5  pt-8 relative duration-300 rounded shadow-md h-full flex flex-col`}
    >
      <div className="flex flex-row items-center justify-between"><div></div>
        <div className="flex gap-x-4 items-center">
          
          <img
            src={`/icons/arm-logo.svg`}
            alt="E-Track Logo"
            className={` h-12 origin-left font-medium text-xl duration-200 ${
              !open && "scale-0"
            }`}
          />
        </div>
        <img
          src="/icons/double-arrow-left.svg"
          className={`cursor-pointer  p-1 w-7 h-7 bg-slate-300
         rounded-full  ${!open && "rotate-180"}`}
          onClick={() => setOpen(!open)}
        />
      </div>

      <ul className="pt-6 h-full m-0 flex flex-col">
      {Menus.map((menu:any, index) => {
              const menuRole = roleMatrix.roleMatrix.find(area => menu.roleId === area.id);
              if (true || menuRole && menuRole.view) {
                  return (
                      <SubMenu
                          key={`submenu-${index}-0-${menu.title}`}
                          index={index}
                          icon={menu.icon}
                          title={menu.title}
                          route={menu.route || ""}
                          open={open}
                          subMenuItems={menu.SubMenuItems?.filter((subMenu:any) => {
                              const subMenuRole = roleMatrix.roleMatrix.find(area => subMenu.roleId === area.id);
                              return true || subMenuRole && subMenuRole.view;
                          })}
                      />
                  );
              }
              return null;
          })}
        <li className="mt-auto">
          <button
            key={`meni-item-logout`}
            className="w-full group flex rounded-md p-2 cursor-pointer hover:bg-light-white items-center gap-x-4 mt-2 bg-slate-100
              hover:bg-mainColor hover:text-white"
            onClick={handleLogout}
          >
            <img
              src={Logout.icon}
              className="block h-6 w-6 duration-200 group-hover:brightness-200 group-hover:invert-1"
            />
            <span className={`${!open && "hidden"} origin-left duration-200`}>
              {Logout.title}
            </span>
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default SideNavbar;
